import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { isDateOnOrAfter, hasLocalStorageKey, formatDateToYYYYMMDD } from '../../../../shared/utils/utils';
import { keysTypes } from '../../../enums/keysTypes';
import { FinalProjectTools, myCoursesFinalProject } from '../../../../shared/utils/entitiesFiltersUtils';
import { usePermission } from '../../../../shared/hooks/usePermission';
import { selectEntitiesByFilters } from '../../../../shared/store/views/entityView';
import FinalProjectCards from '../finalProjectCards/FinalProjectCards';
import FinalProjectHeader from '../finalProjectHeader/FinalProjectHeader';
import Page from '../../../../shared/components/ui/page/Page';
import iconsList from '../../../../shared/components/ui/icons/iconsList';
import pathRouts from '../../../../shared/enums/pathRoute';
import UsefulToolsWidget from '../../../../shared/components/pages/usefulToolsPage/usefulToolsWidget/UsefulToolsWidget';
import FinalProjectPopup from '../finalProjectSubmissionPopup/FinalProjectPopup';
import FinalProjectCoursesWidget from '../finalProjectCoursesWidget/FinalProjectCoursesWidget';
import FinalProjectPortalWidget from '../finalProjectPortalWidget/FinalProjectPortalWidget';
import SubmissionBoxWidget from '../submissionBoxWidget/SubmissionBoxWidget';
import FinalProjectFaceToFaceExamWidget from '../finalProjectFaceToFaceExamWidget/FinalProjectFaceToFaceExamWidget';
import FinalProjectAnnouncementBanner from '../finalProjectAnnouncementBanner/FinalProjectAnnouncementBanner';
import classes from './FinalProjectsPage.module.css';

const FinalProjectsPage = () => {

    const navigate = useNavigate();
    const hasPermission = usePermission();
    const isInFaceToFaceExamWhitelist = hasPermission();
    const [studentData, setStudentData] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [submissionBox, setSubmissionBox] = useState({ startDate: null, deadline: null, isOpen: false, isClosed: false })
    const finalProjectData = useSelector(state => selectEntitiesByFilters(state, myCoursesFinalProject));
    const user = useSelector(state => state.auth?.user);
    const currentDate = new Date();

    const findEventById = (id) => {
        const calendarEvents = finalProjectData?.flatMap(project => project.calendarEvents || []) || [];
        return calendarEvents.find(event => event.id === id);
    };

    useEffect(() => {
        loadStudentData();
        loadSubmissionBoxData();
    }, [finalProjectData]);

    useEffect(() => {
        if (studentData?.presentationDate) {
            if (hasLocalStorageKey(`${keysTypes.presentationPopupShown}_${user?.exidentifier}`)) {
                setShowPopup(true);
                return;
            }
        }
        else if (submissionBox.isOpen && !submissionBox.isClosed) {
            if (hasLocalStorageKey(`${keysTypes.submissionPopupShown}_${user?.exidentifier}`))
                setShowPopup(true);
        }
    }, [studentData?.presentationDate, submissionBox.isOpen]);

    const loadSubmissionBoxData = () => {
        const event = findEventById("3");
        const startDate = formatDateToYYYYMMDD(event?.from);
        const deadline = formatDateToYYYYMMDD(event?.to);
        const isOpen = isDateOnOrAfter(currentDate, startDate);
        const isClosed = isDateOnOrAfter(currentDate, deadline);
        setSubmissionBox({ startDate, deadline, isOpen, isClosed });
    };

    const loadStudentData = () => {
        const event4 = findEventById("4");
        const parseJson = (value) => !value ? null : JSON.parse(value);
        const additionalData = parseJson(finalProjectData?.find(c => c?.addtionalData)?.addtionalData);
        setStudentData({
            projectInformation: {
                subjectName: additionalData?.SubjectName ?? null,
                instructorName: additionalData?.InstructorName ?? null,
                profession: additionalData?.Profession ?? null
            },
            isSubmitted: Boolean(finalProjectData?.find(c => c?.assessments?.length > 0)),
            presentationDate: formatDateToYYYYMMDD(event4?.date),
            presentationTime: 1
        });
    };

    return (
        <Page
            onBack={() => navigate(`/${pathRouts.HOME}`)}
            headerEndContent={<FinalProjectHeader studentData={studentData} submissionBox={submissionBox}/>}
            className={classes.FinalProjectsPage}
        >
            <div className={classes.FinalProjectsPage}>
                {isInFaceToFaceExamWhitelist && <FinalProjectAnnouncementBanner />}
                <div className={classes.FinalProjectsFirstRow}>
                    <div className={classes.FinalProjectsCards}>
                        <FinalProjectCards isSubmitted={studentData.isSubmitted} presentationDate={isInFaceToFaceExamWhitelist} submissionBox={submissionBox} />
                    </div>
                    {isInFaceToFaceExamWhitelist && (
                        <div className={classes.FinalProjectsFaceToFace}>
                            <FinalProjectFaceToFaceExamWidget />
                        </div>
                    )}
                    <div className={classes.FinalProjectsSecondRow}>
                        <div className={classes.FinalProjectsCoursesWidget}>
                            <FinalProjectCoursesWidget presentation={{ date: studentData.presentationDate, time: studentData.presentationTime }} />
                        </div>
                        <div className={classes.FinalProjectsUsefulTools}>
                            <UsefulToolsWidget filter={FinalProjectTools} mainLink={null} />
                        </div>
                        <div className={classes.FinalProjectsBottomRow}>
                            {studentData.presentationDate && (
                                <div className={classes.FinalProjectsSubmissionBox}>
                                    <SubmissionBoxWidget />
                                </div>
                            )}
                            <div className={classes.FinalProjectsPortal}>
                                <FinalProjectPortalWidget />
                            </div>
                        </div>
                    </div>
                </div>

                {showPopup && <FinalProjectPopup isSubmitted={studentData?.isSubmitted} presentationDate={studentData?.presentationDate} submissionBox={submissionBox} onClose={() => setShowPopup(false)} />}
            </div >
        </Page>
    );
};

export default FinalProjectsPage;

